import client from '@/services/';

const state = () => ({
    all: [],
    one: {},
});

const getters = {
    all: state => state.all,
    one: state => state.one,
};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
};

const actions = {
    async getAllP({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '' } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            ...(sort && { sort })
        }).toString();
        let data = await client.get('video/page?' + queryParams);
        commit("SET_ALL", data.data);
        return data.data;
    },
    async getOne(cxt, id) {
        let data = await client.get('video/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async create(cxt, payload) {
        let { data } = payload.id ? await client.put('video/edit/' + payload.id, payload) : await client.post('video/add', payload);
        cxt.commit("SET_ONE", data);
        if (payload.id) {
            payload.id = null;
        }
        return data;
    },
    async del(cxt, id) {
        let { data } = await client.delete('video/delete/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};